export const crumbsFromLocation = location => {

  let currentPath = "/";
  let crumbs = [{
    url: currentPath,
    text: "home"
  }];
  const crumbText = (text) => {
    let response = text;
    switch(text) {
      case "whitepaper":
        response = text.replace(/whitepaper/g, "white paper");
        break;
      default:
        response = text.replace(/-/g, " ");
        break;
    }
    return response;
  };
  let pathName = location.pathname;

  // If there is a category, we need to do some massaging so that /category/catname/ is one link
  let is_category = pathName.search("/blog/category/");
  let category = "";
  if (is_category !== -1) {
    pathName = pathName.replace("/blog/category/", "/blog/");
    category = pathName.match(/blog\/[a-z\-]*\//);
    category = category[0].replace("blog/", "");
    category = category.replace(/^\/|\/$/g, "");
  }

  // If this is paged content, the page link also needs some massaging
  let page_number = "";
  let is_paged = pathName.search("/page/");
  if (is_paged !== -1) {
    page_number = pathName.match(/page\/[1-9]*/);
    page_number = page_number[0].replace("page/", "");
    pathName = pathName.replace("/page", "");
  }

  pathName = pathName.replace(/^\/|\/$/g, "");
  const pathParts = pathName.split("/");
  let itemText = "";
  pathParts.map(item => {
    switch (item) {
      case category:
        currentPath += "category/" + item + "/";
        itemText = crumbText(item);
        break;
      case page_number:
        currentPath += "page/" + item + "/";
        itemText = "Page " + item;
        break;
      default:
        currentPath += item + "/";
        itemText = crumbText(item);
    }
    crumbs.push({
      url: currentPath,
      text: itemText
    });
  });

  return crumbs;
};
